<template>
    <div class="shopping hml_whplt">
        <swiperList :swiperStyle="{padding: '1.25rem 0rem .5rem'}" @exportSwiper="exportSwiper" :setSwiperNumFlag="true">
            <div class="top">
                <ul>
                    <li
                    v-for="(item,index) in list1"
                    :key="index"
                    @click="slideClick1(index)"
                    >
                        <h2>{{ item.title }}</h2>
                        <p>{{ item.keywords }}</p>
                        <img :src="item.thumb">
                    </li>
                </ul>
                <div class="yanse" v-if="list1.length <= 6 && !shoppingFlag">
                    <div @click="seeAll" :style="{backgroundImage: 'url('+ require('@/assets/img/secondLevelPage/seeAll.png') +')'}">
                        查看全部
                        <i></i>
                    </div>
                </div>
            </div>
            <div :class="['swiper-container shoppingSwiper',{shoppingSwiper1: list1.length > 6}]">
                <ul class="swiper-wrapper">
                    <!-- @click="shoppingSlideClick(index)" -->
                    <li
                    class="swiper-slide"
                    v-for="(item,index) in allData[firstLevelIndex].dataArr[secondLevelIndex].list"
                    :key="index"
                    >
                        <div class="img">
                            <img :src="item.thumb">
                        </div>
                        <h2 class="title">{{ item.title }}</h2>
                        <div class="list" v-if="item.area">
                            <span>{{ item.area }}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </swiperList>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
import Swiper from "swiper";
import 'swiper/css/swiper.css';
export default {
    data() { 
        return {
            list1: [],
            swiperObj: null,
        }
    },
    created(){
        let array = this.allData[this.allData.length - 1].dataArr[0].list;
        if(this.shoppingFlag){
            this.list1 = array;
        }else{
            for(let i = 0; i < 6; i++){
                this.list1.push(array[i]);
            }
        }
        
    },
    mounted(){
        if(this.mapJumpListFlag){
            this.setMapJumpListFlag(false);
            this.shoppingSlideClick(this.levelThreeIndex);
        }
        let swiper1 = new Swiper('.shoppingSwiper',{
            slidesPerView: 'auto',
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
        });
    },
    methods: {
        exportSwiper(swiper){
            // console.log(1111111111111111111);
            this.swiperObj = swiper.length > 1 ? swiper[swiper.length - 1] : swiper;
        },
        seeAll(){
            this.list1 = this.allData[this.allData.length - 1].dataArr[0].list;
            this.setShoppingFlag(true);
            setTimeout(() => {
                this.swiperObj.update();
            },100);
        },
        shoppingSlideClick(index){
            this.setSpecialtyState(false);
            this.setIndex({levelThreeIndex: index});
            this.setPlayAroundDetailsFlag(true);
        },
        slideClick1(index){
            this.setSpecialtyState(true);
            this.setIndex({firstLevelIndex: 5,secondLevelIndex: 0,levelThreeIndex: index});
            // this.setPlayAroundDetailsFlag(true);
            this.$router.push("/foodDetails");
        },
        ...publicData.mapMutations(["setIndex","setPlayAroundDetailsFlag","setSpecialtyState",,"setMapJumpListFlag","setShoppingFlag"])
    },
    beforeDestroy(){
        this.setSpecialtyState(false);
    },
    computed: {
        ...publicData.mapState(['allData','firstLevelIndex','secondLevelIndex','levelThreeIndex',"mapJumpListFlag","shoppingFlag"])
    },
}
</script>

<style lang="scss" scoped>
.shopping{
    .top{
        width: 100%;
        height: auto;
        padding: 0 .4rem;
        position: relative;
        ul{
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            li{
                width: 3.2rem;
                height: 3.2rem;
                background: #f2f2f2;
                border-radius: .1rem;
                position: relative;
                padding-top: .38rem;
                padding-left: .2rem;
                overflow: hidden;
                margin-top: .32rem;
                h2{
                    font-size: .4rem;
                    color: #333;
                    font-family: "siyuan";
                }
                p{
                    color: #999;
                    font-size: .28rem;
                    margin-top: .12rem;
                }
                img{
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                }
            }
        }
        .yanse{
            width: 100%;
            height: 2rem;
            position: absolute;
            left: 0;
            bottom: 0rem;
            padding: 0 .4rem;
            div{
                width: 100%;
                height: 100%;
                // background: #fff;
                // background: linear-gradient(rgba(255,255,255,0),rgba(255,255,255,1));
                // box-shadow: 0 0rem 0.3rem 0.6rem rgba(255,255,255,1);
                color: #3289FF;
                font-size: .26rem;
                // margin-top: .3rem;
                display: flex;
                align-items: center;
                justify-content: center;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                i{
                    width: .2rem;
                    height: .2rem;
                    border-top: .04rem solid #3289FF;
                    border-right:  .04rem solid #3289FF;
                    transform: rotate(135deg);
                    margin-left: .1rem;
                    margin-top: -.1rem;
                }
            }
        }
    }
    .shoppingSwiper{
        width: 100%;
        height: auto;
        padding-left: .4rem;
        // margin-top: .6rem;
        &.shoppingSwiper1{
            margin-top: .6rem;
        }
        .swiper-wrapper{
            display: flex;
            // align-items: center;
        }
        li{
            width: 2.4rem;
            height: auto;
            overflow: hidden;
            margin-right: .26rem;
            >.img{
                width: 100%;
                height: 2.4rem;
                overflow: hidden;
                box-shadow:0px .1rem .14rem .02rem rgba(39,39,39,0.1);
                border-radius: .1rem;
                overflow: hidden;
                img{
                    width: 100%!important;
                    height: 100%!important;
                }
            }
            .title{
                font-size: .34rem;
                color: #333;
                margin-top: .28rem;
            }
            .list{
                display: flex;
                align-items: center;
                margin-top: .14rem;
                span{
                    padding: 0 .1rem;
                    height: .34rem;
                    border-radius: .17rem;
                    font-size: .2rem;
                    background:rgba(107,214,195,.2);
                    color: #4EC0AC;
                    line-height: .34rem;
                }
            }
        }
    }
    .shoppingTopListBox{
        width: 100%;
        height: 2rem;
        // background: #fff;
        // box-shadow:0px .04rem 0.7rem 0px rgba(39,39,39,0.14);
        overflow: hidden;
        padding-left: .42rem;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 10;
        box-sizing: content-box;
        padding-top: 1.17rem;
        ul{
            li{
                width: auto;
                flex-direction: column;
                margin-right: .3rem;
                &:last-of-type{
                    margin-right: .6rem;
                }
                >div{
                    width: 1.4rem;
                    height: 1.4rem;
                    // background: #0cf;
                    border-radius: 50%;
                    position: relative;
                    overflow: hidden;
                    box-shadow:0px .15rem .18rem 0px rgba(39,39,39,0.2);
                    border: .06rem solid #DBAC55;
                    img{
                        height: 100%;
                    }
                }
                p{
                    font-size: .24rem;
                    color: #333;
                    margin-top: .2rem;
                    position: relative;
                    text-align: center;
                    // font-family: "zhanku";
                    // letter-spacing: -0.05rem;
                    img{
                        width: 1.16rem;
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom: -.2rem;
                    }
                }
            }
        }
    }
    .shoppingSlide{
        width: 100%;
        height: 2rem;
        display: flex;
        align-items: center;
        .img{
            width: 2rem;
            height: 2rem;
            border-radius: .1rem;
            overflow: hidden;
            margin-right: .3rem;
            img{
                height: 100%;
            }
        }
        .textBox{
            h2{
                color: #333;
                font-size: .34rem;
            }
            p{
                color: #999;
                font-size: .26rem;
                margin-top: .22rem;
            }
            .addr{
                display: flex;
                align-items: center;
                margin-top: .48rem;
                color: #999;
                font-size: .22rem;
                img{
                    width: .3rem;
                    height: .3rem;
                }
            }
        }
    }
}
</style>